<template>
  <div
    class="content"
    style="
      background: #f3f5f9;
      min-height: 100vh;
      padding-top: 55px;
      color: #000000;
    "
  >
    <!-- <title-bar :title="$lang.common_txt135"> </title-bar> -->
    <van-nav-bar
      :title="$lang.common_txt135"
      :border="false"
      fixed
      z-index="99999"
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="20" color="#1F2A47" />
      </template>
    </van-nav-bar>
    <div class="latest-result">
      <div v-if="readFailed && readOnlyMessage" class="lot-readonly-message">
        {{ readOnlyMessage }}
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        loading-text=" "
        @load="loadMore"
        class="order-list"
      >
        <div
          class="latest-result--i m-b-10"
          v-for="(item, index) in lastList"
          :key="index"
        >
          <div class="d-flex-s">
            <div>
              <p class="f-w d-flex f-t-15">
                {{ item.lotteryName }}
                <span class="m-l-5"> ({{ getIssueNo(item) }}) </span>
              </p>
              <p class="m-t-10 f-t-15 f-w">
                {{ formatTime(item) }}
              </p>
            </div>

            <img :src="item.iconUrl" width="60" class="m-r-5" />
          </div>
          <div>
            <div>
              <div class="d-flex-s m-t-5">
                <div
                  v-if="isCryptoLottery(item.lotteryType)"
                  class="d-flex m-t-5"
                  style="flex-flow: wrap row"
                >
                  <p
                    class="lot-qbg"
                    v-for="(item2, index) in splitResult(item.lotteryResult)"
                    :key="index"
                  >
                    {{ item2 }}
                  </p>
                </div>
                <div v-else class="d-flex m-t-5" style="flex-flow: wrap row">
                  <div>
                    <p class="f-t-15 f-w m-b-5">winning:</p>
                    <div class="d-flex" style="flex-flow: wrap row">
                      <p
                        class="lot-qbg"
                        v-for="(item2, index) in getResultBalls(
                          item,
                          'winning'
                        )"
                        :key="index"
                      >
                        {{ item2 }}
                      </p>
                    </div>
                  </div>
                  <div v-if="hasResultMachine(item)">
                    <p class="f-t-15 f-w m-b-5 m-t-5">machine:</p>
                    <div class="d-flex" style="flex-flow: wrap row">
                      <p
                        class="lot-qbg"
                        v-for="(item2, index) in getResultBalls(
                          item,
                          'machine'
                        )"
                        :key="index"
                      >
                        {{ item2 }}
                      </p>
                    </div>
                  </div>
                </div>

                <p
                  v-if="isCryptoLottery(item.lotteryType)"
                  style="
                    background: #ffeb00;
                    color: #1f2a47;
                    height: 30px;
                    width: 70px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                  "
                  @click="goToBin(item.resultBasedOn)"
                >
                  {{ $lang.common_txt181 }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 没有数据时显示 -->
        <van-empty
          v-if="!lastList.length && !loading && !readFailed"
          :image="require('../../../assets/img/common/img_no_data.png')"
          :description="$lang.noempt"
        />
      </van-list>
    </div>

    <div
      style="
        max-width: var(--vk-pc-col);
        width: 100%;
        background: #ffffff;
        position: fixed;
        bottom: 0;
        padding: 10px 0;
        box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
      "
      @click="goToPlay()"
    >
      <p
        style="
          background: #3979e3;
          width: 85%;
          margin: 0 auto;
          text-align: center;
          padding: 12px 0;
          color: #ffffff;
          font-size: var(--vk-fs-15);
          font-weight: bold;
          border-radius: 10px;
        "
      >
        {{ $lang.common_txt207 }}
      </p>
    </div>
    <login v-model="showPopup3" overlay></login>
  </div>
</template>
<script>
// 单国:开奖记录走与国家/币种无关的通用接口(prod 实证三端点返回一致)
import { GetLotteryLatestResults } from '@/api/common'
import { isCryptoLotteryType } from '@/views/layout/lotteryCatalog'
import { openExternalUrl } from '@/views/layout/safeLayout'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { formatLotteryDrawTime, parseLotteryResult, splitLotteryResult } from './lotteryResultSafety'
import {
  isLotteryNeedLoginResponse,
  isLotteryReadOnlyQueryResponse,
  isLotteryReadableResponse,
  lotteryResponseBody,
  lotteryResponseMessage
} from './lotteryResponse'

function guardedLocalStorage() {
  try {
    return safeLocalStorage()
  } catch (e) {
    return null
  }
}

function routeQuery(vm) {
  return vm && vm.$route && vm.$route.query && typeof vm.$route.query === 'object'
    ? vm.$route.query
    : {}
}

function safeJumpTo(vm, ...args) {
  if (vm && typeof vm.$jumpTo === 'function') {
    vm.$jumpTo(...args)
  }
}

export default {
  name: 'LatestResults',
  components: {},
  data() {
    return {
      memberList: [
        this.$lang.common_txt99,
        this.$lang.common_txt100,
        this.$lang.common_txt101,
        this.$lang.common_txt102,
        this.$lang.common_txt103,
        this.$lang.common_txt104,
        this.$lang.common_txt105,
        this.$lang.common_txt106,
        this.$lang.common_txt107,
        this.$lang.common_txt108,
        this.$lang.common_txt109,
        this.$lang.common_txt110
      ],
      lastList: [],
      loading: false, // 是否正在加载更多数据
      finished: false, // 是否已经加载完所有数据
      page: 0, // 当前页码
      pageSize: 20,
      lotteryType: routeQuery(this).lotteryType,
      readOnlyQuery: false,
      readFailed: false,
      readOnlyMessage: '',
      showPopup3: false
    }
  },
  mounted() {
    this.GetNGNDrawHistory()
  },
  methods: {
    firstValue(...values) {
      const hit = values.find((value) => value !== undefined && value !== null && value !== '')
      return hit === undefined ? '' : hit
    },
    responseBody(data) {
      return lotteryResponseBody(data)
    },
    responseErrorPayload(error) {
      if (!error) return error
      if (error.status !== undefined || error.code !== undefined || error.content || error.payload || error.extra || error.page) {
        return error
      }
      return error && (
        (error.response && (error.response.data || error.response.body)) ||
        error.data ||
        error.body ||
        error.content ||
        error
      )
    },
    pickList(data, keys = []) {
      const body = this.responseBody(data)
      const names = keys.concat(['list', 'records', 'dataList', 'historyLotteryInfoList'])
      const search = (source) => {
        if (!source || typeof source !== 'object') return []
        if (Array.isArray(source)) return source
        for (const key of names) {
          if (Array.isArray(source[key])) return source[key]
        }
        for (const key of ['content', 'payload', 'extra', 'page', 'data', 'body']) {
          const list = search(source[key])
          if (list.length) return list
        }
        return []
      }
      return this.safeList(search(body))
    },
    safeList(list) {
      return Array.isArray(list) ? list : []
    },
    hasLogin() {
      return !!safeGetStorageItem(guardedLocalStorage(), 'token')
    },
    safeToast(options) {
      if (typeof this.$toast === 'function') {
        this.$toast(options)
      }
    },
    showNeedLogin() {
      this.showPopup3 = true
    },
    showReadBlocked() {
      if (typeof this.$toast === 'function') {
        this.$toast({
          message: this.readOnlyMessage || this.$lang.common_txt376 || this.$lang.noempt || 'This feature is temporarily unavailable. Please try again later.',
          icon: 'cross'
        })
      }
    },
    getIssueNo(item = {}) {
      return this.firstValue(
        item.issueNo,
        item.issue_no,
        item.currIssueNo,
        item.currentIssueNo,
        '--'
      )
    },
    formatTime(item = {}) {
      const raw = this.firstValue(
        item.lotteryTime,
        item.lottery_time,
        item.drawTime,
        item.draw_time,
        item.openResultTime,
        item.createDate,
        item.create_date
      )
      return formatLotteryDrawTime(raw, this.$dayjs)
    },
    splitResult(value) {
      return splitLotteryResult(value)
    },
    parseResult(value) {
      return parseLotteryResult(value)
    },
    getResultBalls(item = {}, key = 'winning') {
      const result = this.parseResult(item.lotteryResult)
      return this.splitResult(result && typeof result === 'object' ? result[key] : '')
    },
    hasResultMachine(item = {}) {
      return this.getResultBalls(item, 'machine').length > 0
    },
    isCryptoLottery(type) {
      return isCryptoLotteryType(type)
    },
    normalizeHistoryItem(item = {}) {
      const query = routeQuery(this)
      const lotteryResult = this.firstValue(
        item.lotteryResult,
        item.lottery_result,
        item.lottery_num,
        item.openCode,
        item.open_code,
        item.result
      )
      return {
        ...item,
        lotteryName: this.firstValue(item.lotteryName, item.lottery_name, query.lotteryName, '--'),
        lotteryType: this.firstValue(item.lotteryType, item.lottery_type, query.lotteryType),
        iconUrl: this.firstValue(item.iconUrl, item.icon_url),
        lotteryResult,
        resultBasedOn: this.firstValue(item.resultBasedOn, item.result_based_on)
      }
    },
    drawHistoryKey(item) {
      const record = item || {}
      const parts = [
        this.firstValue(record.lotteryType, record.lottery_type),
        this.firstValue(record.issueNo, record.issue_no, record.currIssueNo, record.currentIssueNo),
        this.firstValue(record.lotteryTime, record.lottery_time, record.drawTime, record.draw_time, record.openResultTime, record.createDate, record.create_date),
        this.firstValue(record.lotteryResult, record.lottery_result, record.lottery_num, record.openCode, record.open_code, record.result)
      ].map(value => value === undefined || value === null ? '' : String(value))
      return parts.some(Boolean) ? parts.join('|') : ''
    },
    mergeDrawHistoryList(list) {
      const seen = new Set(this.lastList.map(item => this.drawHistoryKey(item)).filter(Boolean))
      const next = this.safeList(list).filter(item => {
        const key = this.drawHistoryKey(item)
        if (!key) return true
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
      this.lastList = this.lastList.concat(next)
    },
    goToBin(v) {
      if (this.readOnlyQuery || this.readFailed) {
        this.showReadBlocked()
        return
      }
      if (!v) return
      openExternalUrl(v)
    },
    goToPlay() {
      if (!this.hasLogin()) {
        this.showNeedLogin()
        return
      }
      if (this.readOnlyQuery || this.readFailed) {
        this.showReadBlocked()
        return
      }
      const query = routeQuery(this)
      if (typeof this.$jumpTo === 'function') {
        this.$jumpTo(
        '/lotteryDetail',
          {
            lotteryType: query.lotteryType
              ? query.lotteryType
              : 'megasena',
            lotteryName: query.lotteryName
              ? query.lotteryName
              : 'mega-sena'
          },
          { replace: true }
        )
      }
    },
    onClickLeft() {
      const query = routeQuery(this)
      if (query.isFrom === '1') {
        safeJumpTo(this, '/home', {}, { replace: true })
      } else if (query.isFrom === '2') {
        safeJumpTo(this, '/mine', {}, { replace: true })
      } else {
        if (!this.hasLogin()) {
          safeJumpTo(this, '/home', {}, { replace: true })
          return
        }
        safeJumpTo(
          this,
          '/lotteryDetail',
          {
            lotteryType: query.lotteryType,
            lotteryName: query.lotteryName
          },
          { replace: true }
        )
      }
    },
    async GetNGNDrawHistory() {
      this.loading = true
      try {
        const query = routeQuery(this)
        const data = await GetLotteryLatestResults({
          lotteryType: query.lotteryType,
          pageIndex: this.page,
          pageSize: this.pageSize
        })
        this.readOnlyQuery = isLotteryReadOnlyQueryResponse(data)
        this.readFailed = false
        if (isLotteryNeedLoginResponse(data)) {
          this.finished = true
          this.readFailed = true
          this.readOnlyMessage = lotteryResponseMessage(
            data,
            this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now'
          )
          this.showNeedLogin()
          return
        }
        if (isLotteryReadableResponse(data)) {
          this.readOnlyMessage = ''
          const list = this.pickList(data, [
            'list',
            'historyLotteryInfoList',
            'dataList',
            'records'
          ]).map(this.normalizeHistoryItem)
          // 如果没有新数据，表示加载完成
          if (list.length < this.pageSize) {
            this.finished = true
          }

          this.mergeDrawHistoryList(list)
          // 加载下一页
          this.page++
        } else {
          this.finished = true
          this.readFailed = true
          this.readOnlyMessage = lotteryResponseMessage(
            data,
            this.$lang.common_txt376 || this.$lang.noempt || 'This feature is temporarily unavailable. Please try again later.'
          )
          if (typeof this.$toast === 'function') {
            this.$toast({
              message: this.readOnlyMessage,
              icon: 'cross'
            })
          }
        }
      } catch (error) {
        this.finished = true
        this.readFailed = true
        const payload = this.responseErrorPayload(error)
        if (isLotteryNeedLoginResponse(payload)) {
          this.readOnlyMessage = lotteryResponseMessage(
            payload,
            this.$lang.login_txt11 || this.$lang.Entrar || 'Login Now'
          )
          this.showNeedLogin()
          return
        }
        this.readOnlyMessage = lotteryResponseMessage(
          payload,
          this.$lang.common_txt376 || this.$lang.noempt || 'This feature is temporarily unavailable. Please try again later.'
        )
        if (typeof this.$toast === 'function') {
          this.$toast({
            message: this.readOnlyMessage,
            icon: 'cross'
          })
        }
      } finally {
        this.loading = false
      }
    },
    // 加载更多数据
    loadMore() {
      this.GetNGNDrawHistory()
    }
  }
}
</script>
<style lang="less" scoped>
.latest-result {
  padding: 3% 3% 55px 3%;
}
.latest-result--i {
  padding: 10px 15px;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
}
.lot-readonly-message {
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff7e6;
  color: #9a5b00;
  font-size: var(--vk-fs-sm);
  line-height: 1.4;
}
.lot-qbg {
  // background: #f8ff3b;
  background: url('../../../assets/img/lottery/select-q.png') no-repeat;
  // border-radius: 20px;
  background-size: 100% 100%;
  width: 32px;
  height: 32px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  font-weight: bold;
  font-size: var(--vk-fs-xs);
  margin-bottom: 5px;
}
.lot_hh {
  background: url(../../../assets/img/lottery/hua_s.png) no-repeat;
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
::v-deep .van-nav-bar__content {
  background: #ffffff !important;
  color: #000000 !important;
}
::v-deep .van-nav-bar__title {
  color: #000000 !important;
}
::v-deep .van-loading {
  width: 100%;
  height: 100%;
  padding-top: 45%;
  background-color: #ffffff; /* 设置背景颜色 */
}
</style>
